import BoolCell from './BoolCell';

export default BoolCell;
